module.exports = __webpack_public_path__ + "static/media/fi-FI.ecb66e8a.md";